import { render, staticRenderFns } from "./CouponEdit.vue?vue&type=template&id=0ca031c9&scoped=true&"
import script from "./CouponEdit.vue?vue&type=script&lang=ts&"
export * from "./CouponEdit.vue?vue&type=script&lang=ts&"
import style0 from "./CouponEdit.vue?vue&type=style&index=0&id=0ca031c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca031c9",
  null
  
)

export default component.exports